<template>
  <customModal :containerxl="true" @closeModal="closeModal">
<template #title>
  {{ viewMode ? "View Rule" : (isEditMode ? "Update SDV Rule" : "Create SDV Rule") }}
</template>

    <template #body>
      <div class="sdv-rule-body">
         <div :class="{ 'sdv-view-only': viewMode }">
        <!-- ============ 1 · RULE DEFINITION ============ -->
        <div class="sdv-section">
          <div class="sdv-section-head">
            <span class="sdv-step">1</span>
            <span class="sdv-section-title">Rule definition</span>
          </div>

          <div class="row">
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label class="mb-0">
                  Rule Name <sup><i class="fa fa-asterisk required"></i></sup>
                </label>
                <input
                  v-model="rule.ruleName"
                  @input="clearError('ruleName')"
                  class="form-control"
                  type="text"
                />
                <span v-if="errors.ruleName" class="errormsg ml-0">{{
                  errorMessages.ruleName
                }}</span>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-0">
                <label class="mb-0">Rule No</label>
                <input
                  v-model="rule.ruleNo"
                  @input="clearError('ruleNo')"
                  class="form-control"
                  type="text"
                />
                <span v-if="errors.ruleNo" class="errormsg ml-0">{{
                  errorMessages.ruleNo
                }}</span>
              </div>
            </div>
            
          </div>

          <label class="mb-1">
            Rule Type <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <div class="sdv-cards">
            <button
              v-for="opt in ruleTypeOptions"
              :key="opt.value"
              type="button"
              class="sdv-card"
              :class="{ selected: rule.ruleType === opt.value }"
              @click="setRuleType(opt.value)"
            >
              <span class="sdv-card-title">{{ opt.label }}</span>
              <span class="sdv-card-desc">{{ opt.desc }}</span>
            </button>
          </div>
          <span v-if="errors.ruleType" class="errormsg ml-0">{{
            errorMessages.ruleType
          }}</span>
        
         <label class="mb-1" v-if="rule.ruleType === 'Percentage'">
            SDV Coverage <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
<div class="mt-2">
  <!-- Percentage: slider -->
  <div v-if="rule.ruleType === 'Percentage'">
    <div class="sdv-slider-row">
      <input
        type="range"
        min="0"
        max="100"
        step="5"
        v-model.number="rule.sdvPercentage"
      />
      <span class="sdv-pct">{{ rule.sdvPercentage }}%</span>
    </div>
    <p class="sdv-muted mb-0">
      Roughly {{ rule.sdvPercentage }} of every 100 matching data
      points will be flagged for verification.
    </p>
  </div>

  <!-- Sequential: text input for count -->
  <div v-else-if="rule.ruleType === 'Sequential'">
    <div class="form-group mb-0">
      <label class="mb-0">
        Sequence Count
        <sup><i class="fa fa-asterisk required"></i></sup>
      </label>
      <input
        v-model.number="rule.sequenceCount"
        class="form-control"
        type="number"
        min="1"
        placeholder="Number of records to verify in order"
        @input="clearError('sequenceCount')"
      />
      <span v-if="errors.sequenceCount" class="errormsg ml-0">
        {{ errorMessages.sequenceCount }}
      </span>
    </div>
    <p class="sdv-muted mb-0">
      Verify this many matching data points in entry order until the count is met.
    </p>
  </div>

  <!-- Full: static text -->
  <div v-else-if="rule.ruleType === 'Full'">
    <p class="sdv-muted mb-0">Full rules always verify every data point.</p>
  </div>

  <!-- None: static text -->
  <div v-else-if="rule.ruleType === 'None'">
    <p class="sdv-muted mb-0">No source verification will be performed by this rule.</p>
  </div>
</div>


          <div class="sdv-inline-row mt-2">
            <!-- Priority stepper -->
            <div class="sdv-inline-item">
              <label class="mb-0 mr-2">Priority</label>
              <div class="sdv-stepper">
                <button
                  type="button"
                  @click="rule.priority = Math.max(0, rule.priority - 1)"
                >
                  −
                </button>
                <span>{{ rule.priority }}</span>
                <button type="button" @click="rule.priority++">+</button>
              </div>
            </div>

            <!-- Status toggle -->
            <!-- <div class="sdv-inline-item">
              <button
                type="button"
                class="sdv-toggle"
                :class="{ on: rule.status === 'Active' }"
                @click="rule.status = rule.status === 'Active' ? 'Inactive' : 'Active'"
                role="switch"
                :aria-checked="rule.status === 'Active'"
              >
                <span class="sdv-toggle-knob"></span>
              </button>
              <span class="ml-2">{{ rule.status }}</span>
            </div> -->
          </div>
        </div>

        <!-- ============ 2 · FORMS ============ -->
        <div class="sdv-section">
          <div class="sdv-section-head">
            <span class="sdv-step">2</span>
            <span class="sdv-section-title">Forms</span>
            <span class="sdv-section-hint">select a form and its fields</span>
          </div>

          <!-- Form picker -->
          <label class="mb-1">
            Form <sup><i class="fa fa-asterisk required"></i></sup>
          </label>
          <div class="sdv-form-picker" ref="formPicker">
            <div v-if="selectedForm" class="sdv-form-selected">
              <div class="sdv-form-selected-info">
                <span class="sdv-form-name">{{
                  selectedForm.templateName
                }}</span>
                <span class="sdv-form-meta">
                  <template v-if="selectedForm.version"
                    >v{{ selectedForm.version }}</template
                  >
                  <template v-if="selectedForm.category">
                    · {{ selectedForm.category }}</template
                  >
                </span>
              </div>
              <!-- <span
                v-if="selectedForm.status"
                class="sdv-badge"
                :class="
                  selectedForm.status === 'Approved' ? 'approved' : 'draft'
                "
                >{{ selectedForm.status }}</span
              > -->
              <button
                type="button"
                class="sdv-clear-btn"
                title="Change form"
                @click="clearForm"
              >
                ×
              </button>
            </div>

            <button
              v-else
              type="button"
              class="sdv-form-trigger"
              @click="formDropdownOpen = !formDropdownOpen"
            >
              <i class="fa fa-search mr-1"></i>
              {{
                formsLoading ? "Loading study forms…" : "Search study forms…"
              }}
            </button>

            <div
              v-if="formDropdownOpen && !selectedForm"
              class="sdv-form-dropdown"
            >
              <div class="sdv-form-search">
                <input
                  v-model="formSearch"
                  type="text"
                  placeholder="Filter by form name…"
                  autofocus
                />
                <span class="sdv-muted"
                  >{{ filteredForms.length }} / {{ formList.length }}</span
                >
              </div>
              <ul>
                <li v-for="t in filteredForms" :key="t.templateId">
                  <button type="button" @click="selectForm(t)">
                    <span class="sdv-form-name">{{ t.templateName }}</span>
                    <span class="sdv-form-meta"
                      >v{{ t.version
                      }}<template v-if="t.category">
                        · {{ t.category }}</template
                      ></span
                    >
                    <!-- <span
                      class="sdv-badge"
                      :class="t.status === 'Approved' ? 'approved' : 'draft'"
                    >{{ t.status }}</span> -->
                  </button>
                </li>
                <li v-if="!filteredForms.length" class="sdv-empty">
                  No forms match "{{ formSearch }}"
                </li>
              </ul>
            </div>
          </div>
          <span v-if="errors.formId" class="errormsg ml-0">{{
            errorMessages.formId
          }}</span>

          <!-- Field checklist -->
          <div class="mt-2">
            <div v-if="!selectedForm" class="sdv-placeholder">
              Select a form first — its fields will load here.
            </div>
          <div class="sdv-field-list">
  <div class="sdv-field-toolbar">
    <input
      v-model="fieldSearch"
      type="text"
      :placeholder="
        fieldsLoading
          ? 'Loading fields…'
          : 'Filter ' + availableFields.length + ' fields…'
      "
     
    />
    <!-- Disable All/None buttons when Full -->
    <button
      type="button"
      @click="selectAllFields"
    >
      All
    </button>
    <span class="sdv-muted">·</span>
    <button
      type="button"
      @click="clearFields"
      
    >
      None
    </button>
    <!-- Show a note when Full -->
    <!-- <span v-if="rule.ruleType === 'Full'" class="sdv-muted" style="margin-left: auto">
      <i class="fa fa-lock"></i> All fields are selected
    </span> -->
  </div>
  <ul>
    <li v-for="f in filteredFields" :key="f.fieldName">
      <label class="sdv-field-row">
        <input
          type="checkbox"
          :checked="selectedFields.includes(f.fieldName)"
          :disabled="viewMode"
          @change="toggleField(f.fieldName)"
         
        />
        <span class="sdv-field-label">{{ f.label }}</span>
        <code>{{ f.fieldName }}</code>
        <span class="sdv-field-type">{{ f.type }}</span>
      </label>
    </li>
    <li
      v-if="!fieldsLoading && !filteredFields.length"
      class="sdv-empty"
    >
      No matching fields
    </li>
  </ul>
  <div class="sdv-field-footer">
    {{
      selectedFields.length
        ? selectedFields.length +
          " field(s) selected for verification"
        : "No fields selected yet"
    }}
    <span v-if="rule.ruleType === 'Full'" class="sdv-muted">
      (auto‑selected for Full rule)
    </span>
  </div>
</div>
            <span v-if="errors.fields" class="errormsg ml-0">{{
              errorMessages.fields
            }}</span>
          </div>
        </div>

        <!-- ============ 3 · SCOPE ============ -->
        <div class="sdv-section">
          <div class="sdv-section-head">
            <span class="sdv-step">3</span>
            <span class="sdv-section-title">Scope</span>
            <span class="sdv-section-hint">visits and sites</span>
          </div>

          <!-- Sites picker -->
          <div class="mt-3">
            <label class="mb-1"
              >Sites
              <span class="sdv-muted"
                >(optional – leave empty for all)</span
              ></label
            >
            <div class="sdv-form-picker" ref="sitePicker">
              <div
                v-if="selectedSites.length"
                class="sdv-form-selected sdv-multi-selected"
              >
                <div class="sdv-chips" style="border: 0; padding: 0; flex: 1">
                  <span
                    v-for="sid in selectedSites"
                    :key="sid"
                    class="sdv-chip"
                  >
                    {{ getSiteName(sid) }}
                    <button type="button" @click="toggleSite(sid)">×</button>
                  </span>
                </div>
                <button
                  type="button"
                  class="sdv-clear-btn"
                  title="Clear all sites"
                  @click="clearAllSites"
                >
                  ×
                </button>
              </div>

              <button
                type="button"
                class="sdv-form-trigger"
                @click="siteDropdownOpen = !siteDropdownOpen"
              >
                <i class="fa fa-search mr-1"></i>
                {{
                  selectedSites.length
                    ? "Modify sites"
                    : sitesLoading
                    ? "Loading sites…"
                    : "Select sites…"
                }}
              </button>

              <div v-if="siteDropdownOpen" class="sdv-form-dropdown">
                <div class="sdv-form-search">
                  <input
                    v-model="siteSearch"
                    type="text"
                    placeholder="Filter sites…"
                    autofocus
                  />
                  <span class="sdv-muted"
                    >{{ filteredSites.length }} / {{ siteList.length }}</span
                  >
                </div>

                <!-- Toolbar with All/None -->
                <div
                  class="sdv-field-toolbar"
                  style="
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid #eef1f5;
                    padding: 4px 10px;
                    background: #f7f9fb;
                  "
                >
                  <span></span>
                  <div>
                    <button
                      type="button"
                      @click="selectAllSites"
                      style="
                        border: 0;
                        background: transparent;
                        color: #2d6bcf;
                        font-weight: 600;
                        font-size: 12px;
                        cursor: pointer;
                      "
                    >
                      All Sites
                    </button>
                    <span class="sdv-muted">·</span>
                    <button
                      type="button"
                      @click="clearAllSites"
                      style="
                        border: 0;
                        background: transparent;
                        color: #2d6bcf;
                        font-weight: 600;
                        font-size: 12px;
                        cursor: pointer;
                      "
                    >
                      None
                    </button>
                  </div>
                </div>

                <ul>
                  <li v-for="s in filteredSites" :key="s.siteId">
                    <label class="sdv-field-row" style="cursor: pointer">
                      <input
                        type="checkbox"
                        :checked="selectedSites.includes(s.siteId)"
                        @change="toggleSite(s.siteId)"
                      />
                      <span>{{ s.siteCode }} – {{ s.siteName }}</span>
                    </label>
                  </li>
                  <li v-if="!filteredSites.length" class="sdv-empty">
                    No sites match
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Visits picker -->
          <div class="mt-0">
            <label class="mb-1"
              >Visits
              <span class="sdv-muted"
                >(optional – leave empty for all)</span
              ></label
            >
            <div class="sdv-form-picker" ref="visitPicker">
              <div
                v-if="selectedVisits.length"
                class="sdv-form-selected sdv-multi-selected"
              >
                <div class="sdv-chips" style="border: 0; padding: 0; flex: 1">
                  <span
                    v-for="vid in selectedVisits"
                    :key="vid"
                    class="sdv-chip"
                  >
                    {{ getVisitName(vid) }}
                    <button type="button" @click="toggleVisit(vid)">×</button>
                  </span>
                </div>
                <button
                  type="button"
                  class="sdv-clear-btn"
                  title="Clear all visits"
                  @click="selectedVisits = []"
                >
                  ×
                </button>
              </div>

              <button
                type="button"
                class="sdv-form-trigger"
                @click="visitDropdownOpen = !visitDropdownOpen"
              >
                <i class="fa fa-search mr-1"></i>
                {{
                  selectedVisits.length
                    ? "Modify visits"
                    : visitsLoading
                    ? "Loading visits…"
                    : "Select visits…"
                }}
              </button>

              <div v-if="visitDropdownOpen" class="sdv-form-dropdown">
                <div class="sdv-form-search">
                  <input
                    v-model="visitSearch"
                    type="text"
                    placeholder="Filter visits…"
                    autofocus
                  />
                  <span class="sdv-muted"
                    >{{ filteredVisits.length }} / {{ visitList.length }}</span
                  >
                </div>
                <ul>
                  <li v-for="v in filteredVisits" :key="v.visitId">
                    <label class="sdv-field-row" style="cursor: pointer">
                      <input
                        type="checkbox"
                        :checked="selectedVisits.includes(v.visitId)"
                        @change="toggleVisit(v.visitId)"
                      />
                      <span>{{ v.visitFormName }}</span>
                    </label>
                  </li>
                  <li v-if="!filteredVisits.length" class="sdv-empty">
                    No visits match
                  </li>
                </ul>
              </div>
            </div>
          </div>
                   <div class="form-group mt-2">
            <label class="mb-0">Subject</label>
            <input
              v-model="subjectInput"
              class="form-control"
              type="text"
              placeholder="e.g. SUBJ001, SUBJ002, SUBJ003"
            />
          </div>
        </div>

        <!-- ============ 4 · TRIGGER ============ -->
        <div class="sdv-section">
          <div class="sdv-section-head">
            <span class="sdv-step">4</span>
            <span class="sdv-section-title">Trigger</span>
            <span class="sdv-section-hint">when this rule fires</span>
          </div>

          <label class="mb-1 me-2">Trigger Type:</label>
          <div class="sdv-segmented">
            <button
              v-for="t in triggerTypeOptions"
              v-show="t === 'Data Entry'"
              :key="t"
              type="button"
              :class="{ active: rule.triggerType === t }"
              @click="setTriggerType(t)"
            >
              {{ t }}
            </button>
          </div>
          <p
            v-if="rule.triggerType === 'Data Entry'"
            class="sdv-muted mt-1 mb-2"
          >
            SDV is evaluated whenever matching eCRF data is entered or updated.
          </p>
          <p
            v-else-if="rule.triggerType === 'Event-Based'"
            class="sdv-muted mt-1 mb-2"
          >
            SDV is evaluated only when a configured study event occurs.
          </p>

          <div
            class="form-group mt-2 mb-2"
            v-if="rule.triggerType === 'Event-Based'"
          >
            <label class="mb-1 me-2">Trigger Event:</label>
            <div class="sdv-segmented">
              <button
                v-for="te in triggerEventOptions"
                :key="te"
                type="button"
                :class="{ active: rule.triggerEvent === te }"
                @click="rule.triggerEvent = rule.triggerEvent === te ? '' : te"
              >
                {{ te }}
              </button>
            </div>
          </div>

       <div class="form-group mt-2 mb-0" v-if="rule.triggerType === 'Event-Based'">
  <label class="mb-0"
    >Trigger Conditions
    <span class="sdv-muted">(press Enter to add)</span></label
  >
            <div class="sdv-chips">
              <span v-for="c in triggerConditions" :key="c" class="sdv-chip">
                {{ c }}
                <button type="button" @click="removeCondition(c)">×</button>
              </span>
              <input
                v-model="conditionDraft"
                @keydown="onConditionKeydown"
                @blur="addCondition"
                :placeholder="
                  triggerConditions.length ? '' : 'e.g. AE severity = Grade ≥ 3'
                "
              />
            </div>
          </div>
        </div>

        <!-- ============ 5 · SDV COVERAGE ============ -->
        <!-- <div class="sdv-section">
          <div class="sdv-section-head">
            <span class="sdv-step">5</span>
            <span class="sdv-section-title">SDV coverage</span>
          </div>
          <div class="sdv-slider-row">
            <input
              type="range"
              min="0"
              max="100"
              step="5"
              v-model.number="rule.sdvPercentage"
              :disabled="isPercentageLocked"
            />
            <span class="sdv-pct" :class="{ locked: isPercentageLocked }"
              >{{ rule.sdvPercentage }}%</span
            >
          </div>
          <p class="sdv-muted mb-0">
            <template v-if="rule.ruleType === 'Full'"
              >Full rules always verify every data point.</template
            >
            <template v-else-if="rule.ruleType === 'None'"
              >No source verification will be performed by this rule.</template
            >
            <template v-else
              >Roughly {{ rule.sdvPercentage }} of every 100 matching data
              points will be flagged for verification.</template
            >
          </p>
        </div> -->
      </div>
       </div>

      <div class="text-right mt-3" v-if="!viewMode">
        <button
          class="save_btn py-1 px-3"
          @click="submitRule"
          :disabled="isSubmitting"
        >
          <i v-if="isSubmitting" class="fa fa-spinner fa-spin mr-1"></i>
          {{
            isSubmitting
              ? isEditMode
                ? "Updating..."
                : "Creating..."
              : isEditMode
              ? "Update"
              : "Create"
          }}
        </button>
      </div>
    </template>
  </customModal>
</template>
<script src="./ManageSDVRule.js"></script>

<style scoped>
/* (styles unchanged – same as before) */
@import "../../assets/style.css";
@import "../../assets/formpage.css";

.sdv-rule-body {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 4px;
}
.sdv-section {
  margin-bottom: 22px;
}
.sdv-section-head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 10px;
}
.sdv-step {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #2d6bcf;
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.sdv-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2a37;
}
.sdv-section-hint,
.sdv-muted {
  font-size: 12px;
  color: #8a94a6;
}

.sdv-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}
@media (max-width: 767px) {
  .sdv-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}
.sdv-card {
  text-align: left;
  background: #fff;
  border: 1px solid #d7dde6;
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 2px;
  transition: border-color 0.15s, background 0.15s;
}
.sdv-card:hover {
  border-color: #aebccf;
}
.sdv-card.selected {
  border-color: #2d6bcf;
  background: #eef4fd;
  box-shadow: inset 0 0 0 1px #2d6bcf;
}
.sdv-card-title {
  font-size: 13px;
  font-weight: 600;
  color: #1f2a37;
}
.sdv-card-desc {
  font-size: 11.5px;
  color: #6b7686;
  line-height: 1.3;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: normal;
}

.sdv-segmented {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  background: #eef1f5;
  border-radius: 8px;
  padding: 3px;
}
.sdv-segmented button {
  border: 0;
  background: transparent;
  border-radius: 6px;
  padding: 5px 12px;
  font-size: 13px;
  color: #5b6675;
  cursor: pointer;
}
.sdv-segmented button.active {
  background: #fff;
  position: relative;
  color: #1f2a37;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1);
}

.sdv-inline-row {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: center;
}
.sdv-inline-item {
  display: flex;
  align-items: center;
}
.sdv-stepper {
  display: inline-flex;
  align-items: center;
  border: 1px solid #d7dde6;
  border-radius: 8px;
  overflow: hidden;
}
.sdv-stepper button {
  border: 0;
  background: #fff;
  padding: 4px 10px;
  font-size: 14px;
  cursor: pointer;
  color: #5b6675;
}
.sdv-stepper button:hover {
  background: #f3f5f8;
}
.sdv-stepper span {
  min-width: 32px;
  text-align: center;
  font-weight: 600;
  font-size: 13px;
}
.sdv-toggle {
  width: 38px;
  height: 20px;
  border-radius: 999px;
  border: 0;
  background: #cbd2dc;
  position: relative;
  cursor: pointer;
  transition: background 0.15s;
  padding: 0;
}
.sdv-toggle.on {
  background: #22a06b;
}
.sdv-toggle-knob {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
  transition: left 0.15s;
}
.sdv-toggle.on .sdv-toggle-knob {
  left: 20px;
}

.sdv-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  border: 1px solid #d7dde6;
  border-radius: 8px;
  background: #fff;
  padding: 6px 8px;
}
.sdv-chips:focus-within {
  border-color: #2d6bcf;
  box-shadow: 0 0 0 3px rgba(45, 107, 207, 0.12);
}
.sdv-chips input {
  border: 0;
  outline: 0;
  flex: 1;
  min-width: 100px;
  font-size: 13px;
  padding: 2px;
}
.sdv-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: #eef4fd;
  border: 1px solid #c4d8f5;
  color: #1e4e9c;
  border-radius: 6px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
}
.sdv-chip button {
  border: 0;
  background: transparent;
  color: #5f83bd;
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  padding: 0;
}
.sdv-chip button:hover {
  color: #1e4e9c;
}

.sdv-form-picker {
  position: relative;
}
.sdv-form-trigger {
  width: 100%;
  text-align: left;
  border: 1px dashed #c4ccd8;
  border-radius: 8px;
  background: #fff;
  color: #7b8698;
  font-size: 13px;
  padding: 9px 12px;
  cursor: pointer;
}
.sdv-form-trigger:hover {
  border-color: #2d6bcf;
  color: #2d6bcf;
}
.sdv-form-selected {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #9dbdec;
  background: #f2f7fe;
  border-radius: 8px;
  padding: 8px 12px;
}
.sdv-form-selected-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.sdv-form-name {
  font-size: 13px;
  font-weight: 600;
  color: #1f2a37;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.sdv-form-meta {
  font-size: 11.5px;
  color: #8a94a6;
}
.sdv-clear-btn {
  border: 0;
  background: transparent;
  color: #8a94a6;
  font-size: 16px;
  cursor: pointer;
  padding: 0 2px;
}
.sdv-clear-btn:hover {
  color: #1f2a37;
}
.sdv-badge {
  font-size: 10.5px;
  font-weight: 600;
  border-radius: 5px;
  padding: 1px 6px;
  border: 1px solid;
  white-space: nowrap;
}
.sdv-badge.approved {
  color: #17714c;
  background: #e9f8f1;
  border-color: #b8e6d0;
}
.sdv-badge.draft {
  color: #92600a;
  background: #fdf4e3;
  border-color: #f0d9a8;
}

.sdv-form-dropdown {
  position: absolute;
  z-index: 30;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #d7dde6;
  border-radius: 10px;
  box-shadow: 0 12px 28px rgba(16, 24, 40, 0.16);
  overflow: hidden;
}
.sdv-form-search {
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 1px solid #eef1f5;
  padding: 8px 12px;
}
.sdv-form-search input {
  flex: 1;
  border: 0;
  outline: 0;
  font-size: 13px;
}
.sdv-form-dropdown ul {
  list-style: none;
  margin: 0;
  padding: 4px 0;
  max-height: 220px;
  overflow-y: auto;
}
.sdv-form-dropdown li button,
.sdv-form-dropdown li label {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  border: 0;
  background: transparent;
  text-align: left;
  padding: 7px 12px;
  cursor: pointer;
}
.sdv-form-dropdown li button:hover,
.sdv-form-dropdown li label:hover {
  background: #f2f7fe;
}
.sdv-form-dropdown li button .sdv-form-name {
  flex: 1;
  font-weight: 500;
}
.sdv-empty {
  padding: 16px 12px;
  text-align: center;
  font-size: 13px;
  color: #8a94a6;
}

.sdv-placeholder {
  border: 1px solid #e3e8ef;
  background: #f7f9fb;
  border-radius: 8px;
  padding: 14px;
  text-align: center;
  font-size: 13px;
  color: #8a94a6;
}
.sdv-field-list {
  border: 1px solid #d7dde6;
  border-radius: 10px;
  overflow: hidden;
}
.sdv-field-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f7f9fb;
  border-bottom: 1px solid #eef1f5;
  padding: 6px 10px;
}
.sdv-field-toolbar input {
  flex: 1;
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 13px;
}
.sdv-field-toolbar button {
  border: 0;
  background: transparent;
  color: #2d6bcf;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0;
}
.sdv-field-list ul {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 180px;
  overflow-y: auto;
}
.sdv-field-list li + li {
  border-top: 1px solid #f2f4f7;
}
.sdv-field-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 7px 10px;
  cursor: pointer;
  font-weight: 400;
}
.sdv-field-row:hover {
  background: #f2f7fe;
}
.sdv-field-row input[type="checkbox"] {
  margin: 0;
}
.sdv-field-label {
  flex: 1;
  font-size: 13px;
  color: #1f2a37;
}
.sdv-field-row code {
  font-size: 11px;
  color: #8a94a6;
}
.sdv-field-type {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #a3adbd;
  min-width: 52px;
  text-align: right;
}
.sdv-field-footer {
  background: #f7f9fb;
  border-top: 1px solid #eef1f5;
  padding: 5px 10px;
  font-size: 12px;
  color: #5b6675;
}

.sdv-slider-row {
  display: flex;
  align-items: center;
  gap: 14px;
}
.sdv-slider-row input[type="range"] {
  flex: 1;
  accent-color: #2d6bcf;
}
.sdv-slider-row input[type="range"]:disabled {
  opacity: 0.4;
}
.sdv-pct {
  min-width: 56px;
  text-align: center;
  border: 1px solid #d7dde6;
  border-radius: 8px;
  padding: 5px 8px;
  font-size: 13px;
  font-weight: 700;
  color: #1f2a37;
}
.sdv-pct.locked {
  color: #a3adbd;
  background: #f7f9fb;
}

.sdv-multi-selected {
  flex-wrap: wrap;
}
.sdv-multi-selected .sdv-chips {
  flex: 1;
  gap: 4px;
}
/* .sdv-view-only {
  pointer-events: none;
  
} */
.sdv-view-only input,
.sdv-view-only button,
.sdv-view-only textarea {
  pointer-events: none;
}
.sdv-view-only input,
.sdv-view-only textarea {
  background: #f7f9fb;
  color: #5b6675;
}

.sdv-view-only .sdv-form-trigger,
.sdv-view-only .sdv-clear-btn,
.sdv-view-only .sdv-chip button {
  display: none; /* hide affordances that imply editability */
}
</style>
